import { render, staticRenderFns } from "./HeaderActions.vue?vue&type=template&id=bafdd1ec&scoped=true"
import script from "./HeaderActions.vue?vue&type=script&lang=js"
export * from "./HeaderActions.vue?vue&type=script&lang=js"
import style0 from "./HeaderActions.vue?vue&type=style&index=0&id=bafdd1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafdd1ec",
  null
  
)

export default component.exports